/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class ManufacturerAddresponseModel {
   public name: string;
   public path: string;

    constructor(manufacturerAddresponse: any) {
      this.name = manufacturerAddresponse || '';
      this.path = manufacturerAddresponse || '';
    }
  }
